import { render, staticRenderFns } from "./PConfirm.vue?vue&type=template&id=04829830&scoped=true&"
import script from "./PConfirm.vue?vue&type=script&lang=js&"
export * from "./PConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04829830",
  null
  
)

export default component.exports